import { useQuery } from "@tanstack/react-query";
import { getDropboxDocuments } from "@/api";
import { UploadedDocument } from "@/types";

export const useDropboxDocuments = (dealId?: number) => {
  const query = useQuery<UploadedDocument[]>({
    queryKey: ["dropboxDocuments", dealId],
    queryFn: () => getDropboxDocuments(dealId!),
    staleTime: 1000 * 60 * 5,
    enabled: !!dealId,
  });

  return {
    ...query,
    data: query.data || [],
  }
};
